import { createSlice } from '@reduxjs/toolkit'

interface RemoteState {
  cache: string[]
  current: string
  dimensionsFullscreen: any
  dimensionsNormal: any
  scaleFullscreen: any
  scaleNormal: any
}

const initialState: RemoteState = {
  cache: [],
  current: '',
  dimensionsFullscreen: { x: 1024, y: 600 },
  dimensionsNormal: { x: 1024, y: 600 },
  scaleFullscreen: { start: 0, current: 0 },
  scaleNormal: { start: 0, current: 0 },
}

const remote = createSlice({
  name: 'remote',
  initialState,
  reducers: {
    storeRemoteCurrentSuccess(state, action) {
      state.current = action.payload
    },
    storeRemoteCacheSuccess(state, action) {
      state.cache = action.payload
    },
    storeDimensionsFullscreenSuccess(state, action) {
      state.dimensionsFullscreen = action.payload
    },
    storeDimensionsNormalSuccess(state, action) {
      state.dimensionsNormal = action.payload
    },
    storeScaleFullscreenSuccess(state, action) {
      state.scaleFullscreen = action.payload
    },
    storeScaleNormalSuccess(state, action) {
      state.scaleNormal = action.payload
    },
  },
})

export const {
  storeRemoteCurrentSuccess,
  storeRemoteCacheSuccess,
  storeDimensionsFullscreenSuccess,
  storeDimensionsNormalSuccess,
  storeScaleFullscreenSuccess,
  storeScaleNormalSuccess,
} = remote.actions

export default remote.reducer
